import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {removeStorage, setStorage} from '../../../helpers/utilities'
import {setCurrentUser, logoutUser} from '../../slices/authSlice'
import {
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  LogoutResponse,
  RecoverPasswordRequest,
  RecoverPasswordResponse,
} from '../interfaces/auth'

export const URL = `${process.env.REACT_APP_API_URL}/auth/v1/`

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: URL,
  }),
  tagTypes: ['Login'],
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (data) => ({
        url: `login`,
        method: 'Post',
        body: data,
        providesTags: ['Login'],
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        if (!process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY) return

        const {data} = await queryFulfilled
        dispatch(setCurrentUser(data))

        setStorage(
          process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY,
          {
            user: data.responseContent.user,
            enterprise: data.responseContent.enterprise,
            session_id: data.info.sessionId,
          },
          86400
        )
      },
    }),
    logout: builder.mutation<LogoutResponse, LogoutRequest>({
      query: (data) => ({
        url: `logout`,
        method: 'Post',
        body: data,
        providesTags: ['Post'],
      }),
      onQueryStarted(arg, {dispatch, queryFulfilled}) {
        if (!process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY) return
        dispatch(logoutUser())
        removeStorage(process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY)
      },
    }),
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: (data) => ({
        url: `forgot`,
        method: 'Post',
        body: data,
        providesTags: ['Post'],
      }),
    }),
    recoverPassword: builder.mutation<RecoverPasswordResponse, RecoverPasswordRequest>({
      query: (data) => ({
        url: `recover`,
        method: 'Post',
        body: data,
        providesTags: ['Post'],
      }),
    }),
  }),
})

export const {useLoginMutation, useLogoutMutation, useForgotPasswordMutation, useRecoverPasswordMutation} = authApi
